import '@css/main.scss'
import '@js/bootstrap'
import '@js/gsap-setup'

import ScrollTrigger from 'gsap/ScrollTrigger'

import { Header } from '@js/components/Header'
import { Hero } from '@js/components/Hero'
import { Slider } from '@js/components/Slider'
import { Timeline } from '@js/components/Timeline'
import { Archive } from '@js/components/Archive'
import { ProductGallery } from '@js/components/ProductGallery'

import { ReducedMotion } from '@js/animations/ReducedMotion'
import { Scroll } from '@js/animations/Scroll'
import { Mask } from '@js/animations/Mask'
import { Stagger } from '@js/animations/Stagger'
import { Wipe } from '@js/animations/Wipe'
import { Translate } from '@js/animations/Translate'
import { Shape } from '@js/animations/Shape'
import { Zoom } from '@js/animations/Zoom'
import { Counter } from '@js/animations/Counter'
import { Parallax } from '@js/animations/Parallax'
import { SplitReveal } from '@js/animations/SplitReveal'
import { LineDraw } from '@js/animations/LineDraw'
import { TitleSeparator } from '@js/animations/TitleSeparator'
import { BlogFlip } from '@js/animations/BlogFlip'
import { GradientContent } from '@js/animations/GradientContent'

const initApp = () => {
  new ReducedMotion()
  new Scroll()

  const animations = [
    Mask,
    Stagger,
    Wipe,
    Translate,
    Shape,
    Zoom,
    Counter,
    Parallax,
    SplitReveal,
    LineDraw,
    TitleSeparator,
    BlogFlip,
  ]

  animations.forEach((Animation) => {
    new Animation()
  })

  new Header()
  new Hero()
  new Archive()
  new Slider()
  new Timeline()
  new ProductGallery()

  const refreshScrollTrigger = () => ScrollTrigger.refresh()

  refreshScrollTrigger()

  if (document.fonts?.ready) {
    document.fonts.ready.then(refreshScrollTrigger)
  }

  window.addEventListener('load', refreshScrollTrigger, { once: true })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp)
} else {
  initApp()
}
